import React from 'react';
import { Route, Redirect, RouteProps } from 'react-router-dom';
import { useAppContext } from '../context';
import { getAppRedirectUrl, getQueryParamValue } from '../helpers';

interface IUnauthenticatedRouteProps extends RouteProps {
  children: React.ReactElement;
}

const sstRegionUris = [
  'https://sst-uk.elmohub.com.au',
  'https://sst-sg.elmohub.com.au',
  'https://sst-fr.elmohub.com.au',
  'https://sst-gov.elmohub.com.au',
];
const SST_APP_NAME = 'Site Setup Tool';

const UnauthenticatedRoute: React.FC<IUnauthenticatedRouteProps> = ({
  children,
  ...rest
}: IUnauthenticatedRouteProps) => {
  const { isAuthenticated, user, apps } = useAppContext();
  const redirect = getQueryParamValue('redirect');

  return (
    <Route
      {...rest}
      component={() => {
        if (!isAuthenticated || !user) {
          return children;
        } else if (redirect) {
          if (redirect.startsWith('http')) {
            const appInfo = apps?.find((t) => redirect.indexOf(t.appUrl) === 0);
            const isSstOtherRegion = sstRegionUris?.find((sstUrl) =>
              redirect.toLowerCase().startsWith(sstUrl)
            );

            let appToken;
            if (appInfo) {
              appToken = appInfo.appToken;
            } else if (isSstOtherRegion) {
              const sstAppInfo = apps?.find(
                (app) => app.appName === SST_APP_NAME
              );
              appToken = sstAppInfo?.appToken;
            }

            if (appToken) {
              window.location.href = getAppRedirectUrl(redirect, appToken);
            }
          } else {
            return <Redirect to={redirect} />;
          }
        }

        return null;
      }}
    />
  );
};

export default UnauthenticatedRoute;
